/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { useEffect, useState } from "react";
import { IPlannedDownTimeInfo } from "../components/util";
import { applicationApi } from "../services/application-apis/application-apis";
import { logException } from "../services/telemetry/telemetryWrapper";

export const usePlannedDownTimeInfo = () => {
  const [result, setResult] = useState<IPlannedDownTimeInfo>({
    status: "",
    serviceName: "",
    message: "",
  });

  const [loaded, setLoaded] = useState("false");

  useEffect(() => {
    async function fetchPlannedDownTimeInfo() {
      await applicationApi
        .getPlannedDowntime()
        .then((response) => {
          const responsePlannedDownTimeInfo = {
            serviceName: response.data.serviceName,
            status: response.data.status,
            message: response.data.message,
          };
          setResult(responsePlannedDownTimeInfo);
          setLoaded("true");
        })
        .catch((error) => {
          logException(error);
          setResult({
            status: "",
            serviceName: "",
            message: "",
          });
          setLoaded("null");
        });
    }
    fetchPlannedDownTimeInfo();
  }, []);

  return {
    plannedDownTimeInfo: result,
    plannedDownTimeLoaded: loaded,
  };
};
